function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MessageEnum, { getName } from '../Messages/MessageEnum';
import { runEngine } from '../RunEngine';
import { Message } from '../Message';
import { Block } from '../Block';
import StorageProvider from '../StorageProvider';
export default class UserAccountManagerBlock extends Block {
  constructor() {
    super();
    _defineProperty(this, "userCredsKey", 'saveUserInfo');
    this.loadCreds();
    runEngine.attachBuildingBlock(this, [getName(MessageEnum.LoginSuccessMessage), getName(MessageEnum.LoginFaliureMessage), getName(MessageEnum.RequestUserCredentials)]);
  }
  static getInstance() {
    if (!UserAccountManagerBlock.instance) {
      UserAccountManagerBlock.instance = new UserAccountManagerBlock();
    }
    return UserAccountManagerBlock.instance;
  }
  async loadCreds() {
    let storedCreds = await StorageProvider.get(this.userCredsKey);
    if (storedCreds) {
      try {
        const json = JSON.parse(storedCreds);
        this.userName = json.id;
        this.password = json.password;
        this.countryCode = json.countrycode;
      } catch (_unused) {}
    }
  }
  receive(from, message) {
    if (getName(MessageEnum.RequestUserCredentials) === message.id) {
      let message = new Message(getName(MessageEnum.ReciveUserCredentials));
      message.addData(getName(MessageEnum.LoginUserName), this.userName);
      message.addData(getName(MessageEnum.LoginPassword), this.password);
      message.addData(getName(MessageEnum.LoginCountryCode), this.countryCode);
      this.send(message);
    } else if (getName(MessageEnum.LoginSuccessMessage) === message.id) {
      let userName = message.getData(getName(MessageEnum.LoginUserName));
      let password = message.getData(getName(MessageEnum.LoginPassword));
      let countryCode = message.getData(getName(MessageEnum.LoginCountryCode));
      let isRememberMe = message.getData(getName(MessageEnum.LoginIsRememberMe));
      this.saveUserData(countryCode, userName, password, isRememberMe);
    } else if (getName(MessageEnum.LoginFaliureMessage) === message.id) {
      this.clearUserData();
    }
  }
  async saveUserData(countryCode, userName, password, isRememberMe) {
    if (!isRememberMe) {
      this.clearUserData();
    } else {
      try {
        const userInfo = {
          id: userName,
          countrycode: countryCode,
          password: password
        };
        await StorageProvider.set(this.userCredsKey, JSON.stringify(userInfo));
        this.countryCode = countryCode;
        this.userName = userName;
        this.password = password;
      } catch (_unused2) {}
    }
  }
  async clearUserData() {
    await StorageProvider.set(this.userCredsKey, '');
    this.userName = null;
    this.password = null;
    this.countryCode = null;
  }
}